import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IDatasource } from 'utility-ts-orm';
import { Conversation } from '../../builders/conversation_builder';
import { IConversationDatasourceModel } from '../../conversations_interface';
import { ConversationsQuery } from '../../queries/conversations_query';
import { ConversationFilterStrategy } from '../../strategies/conversation_filter_strategy';

export class ConversationListContentController {
  private isLoading: boolean = true;
  private isLoadingMore: boolean = false;
  private isFiltering: boolean = false;
  private filterName: string = '';
  private emptyNotificationString: string = '';
  private filter: string;
  private conversations: Conversation[] = [];

  constructor(
    private loadConversationsCommand: ICommand,
    private ngConversationsQuery: ConversationsQuery,
    private ngConversationDatastore: IDatasource<Conversation, IConversationDatasourceModel>,
    private $state: ng.ui.IStateService
  ) {}

  $onInit() {
    this.loadConversationsCommand(1, this.filter).then(() => {
      this.isLoading = false;
      this.initialize();
    });
  }

  $OnChanges(changes: ng.IChangesObject): void {
    if (_4.isEmpty(changes)) {
      this.initialize();
    }
  }

  initialize(): void {
    this.conversations = ConversationFilterStrategy.getByKey(this.filter).filter(
      this.ngConversationsQuery.result.conversations
    );
    this.emptyNotificationString = _4.get(ConversationFilterStrategy.getByKey(this.filter), 'notificationType', '');
    this.filterName = _4.get(ConversationFilterStrategy.getByKey(this.filter), 'name', '');
    this.isFiltering = this.isFilteringActive();
  }

  isFilteringActive(): boolean {
    const activeFilter = ConversationFilterStrategy.getByKey(this.filter);
    return (
      !_4.isEmpty(activeFilter) &&
      ConversationFilterStrategy.getByKey(this.filter) !== ConversationFilterStrategy.getByOrdinal(0)
    );
  }

  hasConversations(): boolean {
    return !_4.isEmpty(this.conversations);
  }

  loadMoreConversations(): void {
    if (!this.isLoadingMore) {
      this.isLoadingMore = true;
      this.ngConversationDatastore.model.page++;
      this.loadConversationsCommand(this.ngConversationDatastore.model.page, this.filter).then(() => {
        this.initialize();
        this.isLoadingMore = false;
      });
    }
  }

  clearFilter() {
    this.$state.go('my.conversations', { filter: 'all' });
  }
}

export class ConversationListContentComponent implements angular.IComponentOptions {
  public templateUrl: string =
    'capability-ng-conversations/src/components/conversation_list_content/conversation_list_content.html';
  public controller: any = ConversationListContentController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    filter: '<?'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-conversations/src/components/conversation_list_content/conversation_list_content_controller.ts